export const PACE_MAP: Record<number, string> = {
  0: "No lock — self-paced",
  3: "3 days",
  7: "Weekly",
  14: "Fortnightly",
};

export const getPaceDisplay = (pace: number): string => {
  return PACE_MAP[pace] || `${pace} days`;
};
